import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { CallScoringSettingsState, CallScoringSettings, UpdateCallScoringSettingsRequest } from "../types";
import { fetchCallScoringSettings, updateCallScoringSettings } from "../api/callScoringSettingsApi";

const initialState: CallScoringSettingsState = {
  settings: null,
  loading: false,
  saving: false,
  error: null,
  successMessage: null,
};

export const fetchSettings = createAsyncThunk(
  "callScoringSettings/fetchSettings",
  async () => {
    return await fetchCallScoringSettings();
  }
);

export const updateSettings = createAsyncThunk(
  "callScoringSettings/updateSettings",
  async (data: UpdateCallScoringSettingsRequest) => {
    return await updateCallScoringSettings(data);
  }
);

const callScoringSettingsSlice = createSlice({
  name: "callScoringSettings",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch settings
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action: PayloadAction<CallScoringSettings>) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch settings";
      })
      // Update settings
      .addCase(updateSettings.pending, (state) => {
        state.saving = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(updateSettings.fulfilled, (state, action: PayloadAction<CallScoringSettings>) => {
        state.saving = false;
        state.settings = action.payload;
        state.successMessage = "Settings updated successfully";
      })
      .addCase(updateSettings.rejected, (state, action) => {
        state.saving = false;
        state.error = action.error.message || "Failed to update settings";
      });
  },
});

export const { clearError, clearSuccessMessage } = callScoringSettingsSlice.actions;

// Selector will be defined in the component to avoid circular dependencies
// export const selectCallScoringSettings = (state: RootState) => state.callScoringSettings;

export default callScoringSettingsSlice.reducer;